import createAsyncActions from "../../../../utilities/createAsyncActions";
import { createAction } from "redux-actions";
import {
  CLEAR_EXPORT_CLIENT_PROFILE_PDF_EXPORT,
  EXPORT_CLIENT_PROFILE_PDF_EXPORT,
} from "../../types";

export const {
  exportClientProfilePdf,
  exportClientProfilePdfPending,
  exportClientProfilePdfFulfilled,
  exportClientProfilePdfRejected,
} = createAsyncActions(EXPORT_CLIENT_PROFILE_PDF_EXPORT, "exportClientProfilePdf");

export const clearClientProfilePdf = createAction(
  CLEAR_EXPORT_CLIENT_PROFILE_PDF_EXPORT
);



// WEBPACK FOOTER //
// ./src/features/client-profile/actions/getActions/getClientProfilePdfActions.js